<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12">
          <div class="board-wrapper">
            <digit-board
              class="board-items"
              title="Total Signups"
              symbol=""
              :value="ambassadorrefs[0].totalusers"
              color="green"
            ></digit-board>
            <digit-board
              class="board-items"
              title="Total Upgraded Users"
              symbol=""
              :value="ambassadorrefs[0].totalupgradedusers"
              color="green"
            ></digit-board>
          </div>

          <div class="text-center mt-5">
            <div class="">
              <b-modal centered id="modal-ambassador" hide-footer>
                <template v-slot:default>
                  <div class="">
                    <form @submit.prevent="updateamb">
                      <b-form-group
                        label="First Name"
                        class="label"
                        label-for="first_name"
                      >
                        <b-form-input
                          type="text"
                          id="first_name"
                          v-model="ambassador.first_name"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="Last Name"
                        class="label"
                        label-for="last_name"
                      >
                        <b-form-input
                          type="text"
                          id="last_name"
                          v-model="ambassador.last_name"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="Whatsapp Number"
                        class="label"
                        label-for="wphone"
                      >
                        <b-form-input
                          type="text"
                          id="wphone"
                          v-model="ambassador.wphone"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="Location"
                        class="label"
                        label-for="location"
                      >
                        <b-form-input
                          type="text"
                          id="location"
                          v-model="ambassador.location"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group label="Are you a Student?">
                        <b-form-radio
                          v-model="ambassador.student_status"
                          name="status"
                          value="Yes"
                          >Yes</b-form-radio
                        >
                        <b-form-radio
                          v-model="ambassador.student_status"
                          name="status"
                          value="No"
                          >No</b-form-radio
                        >
                      </b-form-group>

                      <b-form-group
                        label="School (Sec School, Higher Institution or Tutorial Academy)"
                        class="label"
                        label-for="target"
                      >
                        <b-form-input
                          type="text"
                          id="school"
                          v-model="ambassador.school"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="Occupation"
                        class="label"
                        label-for="target"
                      >
                        <b-form-input
                          type="text"
                          id="occupation"
                          v-model="ambassador.occupation"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="Account Name"
                        class="label"
                        label-for="target"
                      >
                        <b-form-input
                          type="text"
                          id="acct_name"
                          @input="uppercasename()"
                          v-model="ambassador.acct_name"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="Account Bank Name"
                        class="label"
                        label-for="target"
                      >
                        <b-form-input
                          type="text"
                          id="acct_bank"
                          v-model="ambassador.acct_bank"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="Account Number"
                        class="label"
                        label-for="target"
                      >
                        <b-form-input
                          type="text"
                          id="acct_type"
                          v-model="ambassador.acct_number"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="Account Type"
                        class="label"
                        label-for="target"
                      >
                        <b-form-select v-model="ambassador.acct_type">
                          <b-form-select-option value="null"
                            >--Select Course--</b-form-select-option
                          >
                          <b-form-select-option value="SAVINGS"
                            >SAVINGS</b-form-select-option
                          >
                          <b-form-select-option value="CURRENT"
                            >CURRENT</b-form-select-option
                          >
                        </b-form-select>
                      </b-form-group>

                      <div v-if="sent" class="alert alert-success p-3">
                        Profile Updated Successfully
                      </div>

                      <div class="text-center">
                        <b-overlay
                          :show="sending"
                          rounded
                          opacity="0.6"
                          spinner-small
                          spinner-variant="primary"
                          class=""
                        >
                          <div class="mt-4">
                            <b-button
                              :disabled="chkfields"
                              type="submit"
                              variant="outline-success"
                              class="m-lg-3 mt-2 p-2 action-button"
                            >
                              Update Profile
                            </b-button>
                          </div>
                        </b-overlay>
                        <b-button
                          v-if="sending"
                          @click="sending = false"
                          class="w-50 p-2 mt-3"
                          variant="dark"
                        >
                          Cancel
                        </b-button>
                      </div>
                    </form>
                  </div>
                </template>
              </b-modal>

              <b-button
                class="p-lg-2"
                size="lg"
                v-b-modal.modal-ambassador
                variant="success"
                >Update Ambassador Profile</b-button
              >
              <!-- <b-button class="p-lg-2" @click="openambassador = true" variant="success">ambassador a Coupon Campaign</b-button> -->
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="openambassador == true">
        <b-col class="m-1 p-3"> </b-col>
      </b-row>
      <b-row>
        <b-col class="mt-3">
          <h3 class="text-center">Referrals History</h3>
          <!-- <p class="text-center">Click on any title to edit</p> -->
          <div class="text-center list-heads pt-1">
            <p class="head-p">S/N</p>
            <p class="head-p">Ref Name</p>
            <p class="head-p">Date Registered</p>
            <p class="head-p">Upgraded</p>
            <p class="head-p">Amount Paid</p>
            <p class="head-p">Commission</p>
            <p class="head-p">Date Upgraded</p>
            <!-- <p class="head-p">Uses Count</p> -->
            <!-- <p class="head-p"></p> -->
          </div>

          <div v-if="ambassadorrefs[0].count > 0">
            <ambassadorsList
              class="mt-2 maxres"
              v-for="(referral, index) in useambassadorrefs"
              :sn="index + 1"
              :referral="referral"
              :key="index"
              :page="pages"
              :interval="intervalnum"
            ></ambassadorsList>
            <paginater
              v-if="ambassadorrefs[0].data.length > 0"
              :intervalnum="intervalnum"
              :pages="pages"
              :endss="endss"
              :endnum="endnum"
              :datalength="endss"
              @paginator="newPage"
              @changeInterval="effectInterval"
            ></paginater>
          </div>
          <div v-else>
            <h3>No referrals Yet</h3>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from "@/store";
import ambassadorsList from "@/components/lists/ambassadorsList";
import Paginater from "@/components/Paginater";
import digitBoard from "@/components/digitBoard";

export default {
  components: {
    ambassadorsList,
    Paginater,
    digitBoard
  },

  data() {
    return {
      ambassador: this.getForm(),
      sending: false,
      sent: false,
      levels: [0, 1, 2, 3, 4, 5],
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      btnrange: this.endss,
      pages: 1,
      stockingdata: [
        {
          data: []
        }
      ],
      dataretrieved: false,
      addresponse: "",
      openambassador: false,
      // editor : ClassicEditor,
      // config : config,
      isCheckingcode: false,
      couponexists: false,
      uploadingfile: false,
      uploadedfile: false,
      uploadmessage: "",
      mtype: "",
      filedir: ""
      // datacount : this.partnershipsarray[0].count
    };
  },
  beforeRouteEnter(to, from, next) {
    //   let orgname = store.state.loginmaster.details.clearance_organization
    store.dispatch("dashboard/fetchAmbstat");
    next();
  },
  created() {
    this.ambassador = {
      first_name: this.ambdetails.ambassador_first_name,
      last_name: this.ambdetails.ambassador_last_name,
      wphone: this.ambdetails.ambassador_wphone,
      location: this.ambdetails.ambassador_location,
      school: this.ambdetails.ambassador_school,
      student_status: this.ambdetails.ambassador_student_status,
      occupation: this.ambdetails.ambassador_occupation,
      acct_name: this.ambdetails.ambassador_account_name,
      acct_bank: this.ambdetails.ambassador_account_bank,
      acct_type: this.ambdetails.ambassador_account_type,
      acct_number: this.ambdetails.ambassador_account_number
    };
  },
  computed: {
    ...mapState({
      users: state => state.admin.allusers,
      details: state => state.loginmaster.details,
      ambdetails: state => state.loginmaster.details.ambassador_details,
      ambassadorrefs: state => state.dashboard.ambstat,
      adminadded: state => state.admin.adminadded,
      environ: state => state.loginmaster.environ,
      origin: state => state.loginmaster.site_origin
    }),
    emails() {
      let emailss = this.users;
      return emailss.map(x => x.email);
    },
    useambassadorrefs() {
      return this.ambassadorrefs[0].data.slice(this.startnum, this.endnum);
    },
    endss() {
      let end = this.ambassadorrefs[0].data.length;
      return end;
    },
    ranger() {
      let ranger = Math.ceil(
        this.ambassadorrefs[0].data.length / this.intervalnum
      );
      return ranger;
    },
    chkfields() {
      if (
        this.sending ||
        this.ambassador.first_name.length <= 0 ||
        this.ambassador.student_status.length <= 0 ||
        this.ambassador.acct_name.length <= 0 ||
        this.ambassador.acct_bank.length <= 0 ||
        this.ambassador.acct_type.length <= 0 ||
        this.ambassador.acct_number.length <= 0 ||
        this.ambassador.last_name.length <= 0 ||
        this.ambassador.wphone.length <= 0 ||
        this.ambassador.location.length <= 0
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions("dashboard", ["updateAmb", "fetchAmbstat"]),
    getForm() {
      return {
        first_name: 1,
        last_name: "",
        wphone: "",
        location: "",
        student_status: "",
        occupation: "",
        acct_type: "",
        acct_name: "",
        acct_bank: "",
        acct_number: ""
      };
    },
    uppercasename() {
      this.ambassador.acct_name =
        this.ambassador.acct_name.charAt(0).toUpperCase() +
        this.ambassador.acct_name.slice(1);
    },
    updateamb() {
      this.sending = true;

      this.ambassador.email = this.ambdetails.ambassador_email;

      return this.updateAmb(this.ambassador).then(() => {
        this.sending = false;
        this.sent = true;

        // this.fetchAmb();
      });
    },
    newPage(page) {
      // alert(page)
      this.pages = page;
      let newend = this.intervalnum * page;

      if (newend < this.endss) {
        this.endnum = newend;
        this.startnum = newend - this.intervalnum;
      } else {
        this.endnum = this.endss;
        this.startnum = newend - this.intervalnum;
      }
    },
    effectInterval(newinterval) {
      this.intervalnum = newinterval;
      this.pages = 1;
      this.newPage(this.pages);
    },

    checkCouponcode() {
      this.ambassador.couponcode = this.ambassador.couponcode.toUpperCase();

      if (this.ambassador.couponcode.length > 0) {
        this.isCheckingcode = true;
      } else {
        this.isCheckingcode = false;
      }

      // alert(this.ambassador.couponcode)

      return this.checkCoupon(this.ambassador.couponcode).then(response => {
        this.couponexists = response;
        // console.log(response)
      });
    },
    stopproceed() {
      this.sending = false;
    }
  }
};
</script>

<style scoped>
.list-heads {
  background-color: #00984a;
  color: white;
  border-radius: 5px 5px;
  font-weight: bold;
  display: flex;
  flex-flow: row wrap;
}
.head-p {
  width: 14%;
  padding: 2px;
}
.flex-input-parent {
  display: flex;
}
.left-flex-child {
  width: 95%;
}
.right-flex-child {
  width: 5%;
}
.hidden {
  display: none;
}
.full-width-child {
  width: 100%;
}
.font-green {
  color: green;
}
.errtxt {
  color: red;
}
.board-wrapper {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
}
.board-items {
  width: 30%;
  margin: 3px;
}

@media screen and (max-width: 999px) {
  .head-p {
    font-size: 0.6rem;
  }
  .page-buttons {
    width: 25px;
    height: 25px;
    padding: 0px 0px 0px 5px;
  }
}
</style>
